(function () {
  'use strict';

  /* @ngdoc object
   * @name trainingRoster
   * @description
   *
   */
  angular
    .module('trainingRoster', [
      'ui.router'
    ]);
}());
